import React from "react";
import "./AirFreshenerManufacture.css";
import HaveAScent from "../../Components/HaveAScent";

const AirFreshenerManufacture = () => {
  return (
    <div>
      <p className="mt-[50px] mb-[50px] text-black text-5xl text-center">
        AIR FRESHENER
      </p>

      <div className="w-full h-[50vh] bg-[#326A0A] flex justify-center items-center">
        <p className="typing-text w-[80%] text-center text-5xl sm:m-10 text-white">
          Clean Air, Fresh Spaces
        </p>
      </div>


            {/* ========================= */}
      {/* Earth Beauty & You Section */}
      {/* ========================= */}
      <div className="w-[90%] lg:w-[70%] mx-auto my-20 bg-gradient-to-r from-[#f8fff4] to-[#ffffff]  overflow-hidden">
        <div className="flex flex-col lg:flex-row items-center gap-10 p-8 lg:p-12">
          <div className="lg:w-2/3 flex justify-center">
            <img
              src="https://i.ibb.co.com/dJVP8JMH/nextcare-ebay.avif"
              alt="Earth Beauty & You Air Freshener"
              className="w-full  object-contain transition duration-300 hover:scale-105"
            />
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block bg-[#326A0A] text-white px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-wider mb-4">
              Earth Beauty & You
            </span>

            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Premium Air Freshener Collection
            </h2>

            <p className="text-lg text-gray-700 leading-8 mb-5">
              Earth Beauty & You Air Fresheners are expertly manufactured using
              carefully selected fragrance oils, odor-neutralizing ingredients,
              and advanced blending techniques to provide long-lasting freshness
              for homes, offices, vehicles, and commercial spaces.
            </p>

            <p className="text-lg text-gray-700 leading-8 mb-8">
              Every formulation is developed under strict quality control to
              ensure a balanced fragrance, consistent performance, and a clean,
              refreshing atmosphere. Explore our complete collection of premium
              air fresheners available in a variety of unique and captivating
              scents.
            </p>

            <a
              href="https://earthbeautyandyou.com/product-category/air%20freshener"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-[#326A0A] hover:bg-[#254f07] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105">
                See Details →
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Section 1 */}
      <div className="w-[90%] lg:w-[70%] mx-auto my-10 flex flex-col lg:flex-row items-center gap-10">
        <div className="sm:w-[50%]">
          <p className="text-3xl my-6 font-bold">
            The Air Freshener Manufacturing Process
          </p>

          <p className="text-xl my-3">
            Air fresheners are crafted to deliver a pleasant aroma that
            eliminates bad odors and refreshes the air in any space. Our process
            begins with selecting high-quality essential oils and fragrances
            that are both long-lasting and safe for the environment.
          </p>

          <p className="text-xl my-3">
            The air freshener solution is carefully blended with a mixture of
            oils, water, and neutralizing agents to ensure the product is
            effective while maintaining a gentle and balanced scent.
          </p>
        </div>

        <img
          className="sm:w-[50%]"
          src="https://i.ibb.co/mFJW40Tm/air-freshner.png"
          alt="Air Freshener Process"
        />
      </div>

      {/* Section 2 */}
      <div className="w-[90%] sm:w-[70%] mx-auto my-10 flex flex-col lg:flex-row-reverse items-center gap-10">
        <div className="sm:w-[50%]">
          <p className="mb-6 text-2xl">
            Our expert team combines the perfect ratios of essential oils and
            odor-neutralizing compounds to produce an air freshener that keeps
            your space smelling fresh all day long.
          </p>

          <p className="mb-6 text-xl">
            We prioritize eco-friendly ingredients, ensuring that each air
            freshener is not only effective but also safe for both you and the
            environment. Our air fresheners are free from harmful chemicals and
            are designed for long-lasting results.
          </p>

          <p className="mb-6 text-xl">
            With a variety of scents to choose from, our air fresheners provide
            the perfect solution for creating a comfortable and pleasant
            environment, wherever you go.
          </p>
        </div>

        <img
          className="sm:w-[50%]"
          src="https://www.thespruce.com/thmb/SU-0B6BUBaR-2ARnmD5t7G9Y_84=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/green-diy-air-fresheners-1706905_01-25c514dee9324842888dadbaf811ac9a.jpg"
          alt="Air Freshener Production"
        />
      </div>



      {/* Have A Scent */}
      <HaveAScent color="#326A0A" />
    </div>
  );
};

export default AirFreshenerManufacture;